import styled from 'styled-components';

export const RedText = styled.span`
  color: red;
`;

export const BlueText = styled.span`
  color: blue;
`;

export const BigBold = styled.span`
  font-size: 20px;
  font-weight: bold;
`;

export const ErrorMessage = styled.div`
  color: maroon;
`;

export const SuccessMessage = styled.div`
  color: green;
`;

export const HeaderTD = styled.td`
  background-color: lightgray;
  border: 1px solid white;
`;

export const TD1 = styled.td`
  background-color: white;
  border: 1px solid white;
`;

export const TD2 = styled.td`
  background-color: #f2f8ff;
  border: 1px solid white;
`;